import type { ChangeEventHandler } from 'react'

import type { UseFormRegister } from 'react-hook-form'

import { lang } from '@lib/constants'

export const maskPhoneNumber = (value: string) => {
	// TODO: handle ES + UK country codes
	// If value coming in starts with country code
	if (lang === 'en-us') {
		if (value.startsWith('+1')) {
			// eslint-disable-next-line no-param-reassign
			value = value.slice(2)
		}
		// Remove all non digit values
		// eslint-disable-next-line no-param-reassign
		value = value.replace(/\D/g, '')

		// Add parenthesis, space, and hyphen
		if (value.length > 3) {
			const areaCode = value.slice(0, 3)
			const beforeHyphen = value.slice(3, 6)
			const afterHyphen = value.slice(6, 10)

			// eslint-disable-next-line no-param-reassign
			value = `(${areaCode}) ${beforeHyphen}${afterHyphen ? `-${afterHyphen}` : ''}`
		}
	}

	return value
}

type PhoneNumberInputProps = {
	register: UseFormRegister<any>
	placeholder?: string
	id?: string
	required?: boolean
	autocomplete?: string
	errors?: string
}

export default function PhoneNumberInput({
	register,
	// eslint-disable-next-line no-nested-ternary
	placeholder = lang === 'en-us' ? 'Phone' : lang === 'en-gb' ? 'ex. +44 Phone' : 'ex. +34 Phone',
	id = 'phone',
	required = true,
	errors
}: PhoneNumberInputProps) {
	const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
		// eslint-disable-next-line no-param-reassign
		event.target.value = maskPhoneNumber(event.target.value)
	}

	return (
		<div className="flex-1 flex flex-col gap-y-2">
			<div className="form-control">
				<input
					className={`input ${errors ? 'error' : ''}`}
					type="tel"
					autoComplete="tel"
					required={required}
					id={id}
					maxLength={14}
					{...register(id, {
						required,
						onChange: handleChange
					})}
				/>

				{/* Placeholder */}
				<label htmlFor={id} className="label">
					{placeholder}
				</label>
			</div>
			{errors && <p className="py-2 error-message">{errors}</p>}
		</div>
	)
}
